import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import PageMessage from '../PageMessage';
import infoIcon from './assets/info.svg';
import styles from './index.module.less';

class MXItemsImporter extends Component {
  static propTypes = {
    draftCount: PropTypes.number.isRequired,
    campDiffsCount: PropTypes.number,
    type: PropTypes.string,
    onActionClick: PropTypes.func,
    intl: PropTypes.shape({
      formatMessage: PropTypes.func,
    }).isRequired,
  };

  static defaultProps = {
    onActionClick: null,
    type: '',
    campDiffsCount: 0,
  };

  getItemsCount = () => {
    const {
      draftCount,
      campDiffsCount,
      intl: { formatMessage },
    } = this.props;

    return (
      <div className={styles.itemsCountParent}>
        {draftCount > 0 && (
          <div className={styles.singleItemCount}>
            {formatMessage({ id: 'message.newItems' })}: <span>{draftCount}</span>
          </div>
        )}
        {campDiffsCount > 0 && (
          <div className={styles.singleItemCount}>
            {formatMessage({ id: 'message.itemsForReview' })}: <span>{campDiffsCount}</span>
          </div>
        )}
      </div>
    );
  };

  getMessageText = () => {
    const {
      draftCount,
      campDiffsCount,
      intl: { formatMessage },
    } = this.props;

    if (draftCount > 0 && campDiffsCount > 0) {
      return formatMessage({ id: 'message.mixedItemsNeedReview' });
    }
    if (draftCount > 0) {
      return formatMessage({ id: 'message.draftItemsNeedReview' });
    }
    if (campDiffsCount > 0) {
      return formatMessage({ id: 'message.campDiffsNeedReview' });
    }
    return '';
  };

  showReviewModal = () => {
    this.props.onActionClick();
  };

  render() {
    const {
      draftCount,
      campDiffsCount,
      intl: { formatMessage },
      type,
    } = this.props;
    const totalCount = draftCount + campDiffsCount;

    return totalCount > 0 ? (
      <PageMessage
        type="warning"
        typeIcon={infoIcon}
        text={this.getMessageText()}
        actionDescription={type === 'draftsOnly' ? null : this.getItemsCount()}
        actionText={type === 'draftsOnly' ? null : formatMessage({ id: 'message.startReviewing' })}
        actionFunction={() => this.showReviewModal()}
        data-test="pageMessage"
      />
    ) : null;
  }
}

export default injectIntl(MXItemsImporter);
